import React from 'react';

import {formatISO} from 'date-fns';
import {useStore} from 'effector-react';
import {useTranslation} from 'react-i18next';

import {Button, ButtonVariant} from 'components/ui-kit/Button';
import {Modal} from 'components/ui-kit/Modal';

import {
    recallData$,
    recallGtinFx,
    showRecallApproveModal$,
    showRecallApproveModalChanged,
} from 'models/registries/gtinsGrid/upload';

import {useRecallDocument} from '../useRecallDocument';

import {ButtonWrapper, ModalText, Root} from './styled';

export const RecallApproveModal = () => {
    const {t} = useTranslation();
    const recallData = useStore(recallData$);
    const isModalOpen = useStore(showRecallApproveModal$);
    const recallDocument = useRecallDocument(JSON.stringify(recallData));
    const onClose = () => {
        if (recallDocument.pending) return;
        showRecallApproveModalChanged(false);
    };

    const onRecall = async () => {
        const success = await recallDocument.submit(
            {
                productCode: recallData.productCode,
                reason: recallData.reason,
                ...(recallData.batchNumber && {batchNumber: recallData.batchNumber}),
                ...(recallData.comment && {comment: recallData.comment}),
                ...(recallData.documentNumber && {
                    regulatorDocumentNumber: recallData.documentNumber,
                }),
                ...(recallData.recallDate && {
                    recallDecisionDate: formatISO(recallData.recallDate),
                }),
            },
            recallGtinFx,
        );
        if (success) showRecallApproveModalChanged(false);
    };

    return (
        <Modal
            modalWidth={0}
            show={isModalOpen}
            onClose={onClose}
            title={t('pages.products.recallForm.recallConfirmationModal.title')}
        >
            <Root>
                <ModalText>
                    {t('pages.products.recallForm.recallConfirmationModal.description')}
                </ModalText>
                <ButtonWrapper>
                    <Button
                        size="sm"
                        variant={ButtonVariant.Outline}
                        disabled={recallDocument.pending}
                        onClick={onClose}
                    >
                        {t('pages.products.recallForm.recallConfirmationModal.cancel')}
                    </Button>
                    <Button
                        size="sm"
                        variant={ButtonVariant.Normal}
                        isLoading={recallDocument.pending}
                        onClick={onRecall}
                    >
                        {t('pages.products.recallForm.recallConfirmationModal.recall')}
                    </Button>
                </ButtonWrapper>
            </Root>
        </Modal>
    );
};
